var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showMask)?_c('span',{staticClass:"oxy-panel-mask",on:{"click":_vm.closeMask}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }